import { __assign, __awaiter, __extends, __generator, __spreadArray } from "tslib";
import { FrameOpener } from '@wix/frame-opener';
import { childIncomingActions, parentIncomingActions, } from './actions';
import { OpenerVersion } from './scenarios/GenericInputParams';
import { Scenarios } from './scenarios/Scenarios';
import { videoMakerAppPreLoad } from './services/biLogger';
import { generateSessionId } from './services/generateSessionId';
export var biContext;
(function (biContext) {
    biContext["New"] = "new";
    biContext["Edit"] = "edit";
})(biContext || (biContext = {}));
export var InstanceErrorMessage;
(function (InstanceErrorMessage) {
    InstanceErrorMessage["NoInstanceInResult"] = "video-maker-opener: can't get instance from method \"withInstanceGetter\"";
    InstanceErrorMessage["NotProvidedMethodWithInstanceGetter"] = "video-maker-opener: withInstanceGetter method is not provided";
})(InstanceErrorMessage || (InstanceErrorMessage = {}));
/**
 * Api to work with Video Maker Modal:
 *  - open/close modal
 *  - send/receive messages to/from Modal
 *
 */
var modalUrlPath = 'video-maker-modal/modal';
var VideoMakerOpener = /** @class */ (function (_super) {
    __extends(VideoMakerOpener, _super);
    function VideoMakerOpener(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.baseUrl, baseUrl = _c === void 0 ? typeof location !== 'undefined' &&
            location.host.endsWith('editorx.com')
            ? "https://manage.editorx.com/".concat(modalUrlPath)
            : "https://www.wix.com/".concat(modalUrlPath) : _c, url = _b.url;
        var _this = _super.call(this, {
            incomingActions: parentIncomingActions,
            outgoingActions: childIncomingActions,
            url: function (_a) {
                var debug = _a.debug, metaSiteId = _a.metaSiteId;
                var consentPolicyParams = '';
                if (window.consentPolicyManager) {
                    consentPolicyParams = Object.entries(window.consentPolicyManager._getConsentPolicyHeader())
                        .reduce(function (acc, _a) {
                        var key = _a[0], value = _a[1];
                        return __spreadArray(__spreadArray([], acc, true), ["".concat(key, "=").concat(value)], false);
                    }, [])
                        .join('&');
                }
                var commonConfigValue = window.commonConfig
                    ? encodeURIComponent(JSON.stringify(window.commonConfig))
                    : undefined;
                var commonConfigParam = commonConfigValue
                    ? "&commonConfig=".concat(commonConfigValue)
                    : '';
                return "".concat(baseUrl, "?metaSiteId=").concat(metaSiteId).concat(debug ? '&debug' : '').concat(consentPolicyParams ? '&' + consentPolicyParams : '').concat(commonConfigParam);
            },
            frameId: 'video-maker-modal',
        }) || this;
        _this.isFirst = true;
        _this.sessionId = generateSessionId();
        if (url) {
            console.error("deprecated usage of 'url' parameter");
        }
        document.addEventListener('consentPolicyChanged', function () {
            if (!window.consentPolicyManager || !_this.targetWindow) {
                return;
            }
            _this.emit(childIncomingActions.consentPolicyChanged(window.consentPolicyManager.getCurrentConsentPolicy().policy));
        });
        return _this;
    }
    /**
     * Set manager that will be used in each class creation. Useful for testing
     * @param manager Manager for new instances of VideoMakerOpener
     */
    VideoMakerOpener.setDefaultWindowManager = function (manager) {
        _super.setDefaultWindowManager.call(this, manager);
    };
    /**
     * set instance receiver
     * @param instanceGetter function must returns the instance is a signed token, used for identifying Applications and services
     * (see more https://bo.wix.com/wix-docs/rest/getting-started#authentication)
     * @returns instance of VideoMakerOpener
     */
    VideoMakerOpener.prototype.withInstanceGetter = function (instanceGetter) {
        this.instanceGetter = instanceGetter;
        return this;
    };
    /**
     * Open Video Maker Modal
     * @param settings Settings for opener
     * @returns Promise Promise that will be resolved when modal successfully initialized
     */
    VideoMakerOpener.prototype.open = function (settings) {
        var _this = this;
        var instanceGetter = this.instanceGetter;
        if (!instanceGetter) {
            throw new Error(InstanceErrorMessage.NotProvidedMethodWithInstanceGetter);
        }
        this.sessionId = generateSessionId();
        var resultSettings = __assign(__assign({}, settings), { isFirst: this.isFirst, sessionId: this.sessionId, openerVersion: OpenerVersion.V2 });
        this.__sendOpenEvent(settings);
        this.on(parentIncomingActions.getInstanceRequest, function () { return __awaiter(_this, void 0, void 0, function () {
            var instance, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, instanceGetter()];
                    case 1:
                        instance = _a.sent();
                        if (!instance) {
                            throw new Error(InstanceErrorMessage.NoInstanceInResult);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.emit(childIncomingActions.getInstanceFailed(error_1));
                        throw error_1;
                    case 3:
                        this.emit(childIncomingActions.getInstanceSuccessful(instance));
                        return [2 /*return*/];
                }
            });
        }); });
        return _super.prototype.open.call(this, resultSettings).then(function () {
            _this.isFirst = false;
        });
    };
    /**
     * @private
     */
    VideoMakerOpener.prototype.kill = function () {
        _super.prototype.kill.call(this);
    };
    /**
     * Close Video Maker Modal and remove it from DOM
     */
    VideoMakerOpener.prototype.close = function () {
        _super.prototype.close.call(this);
    };
    /**
     * Subscribe to events from Video Maker Modal
     * @param event Event type that will be send by modal
     * @param handler Handle function that will process event
     * @param once Whether to call handler once or on each event
     * @returns Returns unsubscribe function
     */
    VideoMakerOpener.prototype.on = function (event, handler, once) {
        return _super.prototype.on.call(this, event, handler, once);
    };
    /**
     * Unsubscribe from  events from Video Maker Modal
     * @param event Event type that will be send by modal
     * @param handler Handle function that was specified during subscription
     */
    VideoMakerOpener.prototype.off = function (event, handler) {
        _super.prototype.off.call(this, event, handler);
    };
    /**
     * Subscribe to one event from Video Maker Modal
     * @param event Event type that will be send by modal
     * @param handler Handle function that will process event
     * @returns Returns unsubscribe function
     */
    VideoMakerOpener.prototype.once = function (event, handler) {
        return _super.prototype.once.call(this, event, handler);
    };
    /**
     * @private
     * @ignore
     */
    VideoMakerOpener.prototype.setTarget = function (target) {
        _super.prototype.setTarget.call(this, target);
    };
    VideoMakerOpener.prototype.getContext = function (scenario) {
        return scenario === Scenarios.Edit ? biContext.Edit : biContext.New;
    };
    VideoMakerOpener.prototype.__sendOpenEvent = function (settings) {
        videoMakerAppPreLoad({
            metaSiteId: settings.metaSiteId,
            isFirst: this.isFirst,
            origin: settings.origin,
            source: settings.opener,
            sessionId: this.sessionId,
            context: this.getContext(settings.scenario),
        });
    };
    return VideoMakerOpener;
}(FrameOpener));
export { VideoMakerOpener };
//# sourceMappingURL=VideoMakerOpener.js.map